import React from "react";
import { Redirect, useParams } from "react-router-dom";
import { FieldTripParams } from "./consts";

export default function Complete() {
  const params = useParams<FieldTripParams>();
  return <Redirect to={`/field_trip_detail/${params.tripId}`} />;
}
